<template>
	<div v-if="item.is_available && item.services" class="cd-services-section">
		<div class="cd-services-title"><BaseCmsLabel code="services_title" /></div>
		<div v-for="item in item.services" :key="item.code" class="cd-service" :class="[item.code, {'active': (item.code === 'service' && serviceActive) || (item.code === 'insurance' && insuranceActive)}]" @click="flyoutService(item.code)">
			<div class="cd-service-title" :class="[item?.code]">
				<span class="unselected">{{ item?.title }}</span>
				<span v-if="item?.type == 's'" class="selected" v-html="labels.get('service_title_zavarovanje_selected')"></span>
				<span v-else-if="item?.type == 'c'" class="selected" v-html="labels.get('service_title_storitve_selected')"></span>
			</div>
			<div class="cd-service-bid" :class="[item?.code]">
				<div v-for="(item, index) in serviceBid[item?.code]" :key="index" class="cd-flyout-service-title">
					<span class="title">{{ item?.title }}</span>
					<span class="cd-flyout-service-price">
						<span>{{ formatCurrency(item?.price) }}</span>
					</span>
				</div>
			</div>
			<div class="cd-service-note">
				<template v-if="item?.type == 's'">
					<span class="unselected" v-html="labels.get('service_note_zavarovanje')"></span>
					<span class="selected" v-html="labels.get('service_note_zavarovanje_selected')"></span>
				</template>
				<template v-else-if="item?.type == 'c'">
					<span class="unselected" v-html="labels.get('service_note_storitve')"></span>
					<span class="selected" v-html="labels.get('service_note_storitve_selected')"></span>
				</template>
			</div>
		</div>
	</div>
</template>

<script setup>
	const labels = useLabels();
	const props = defineProps(['item']);
	const {formatCurrency} = useCurrency();
	const {bus, emit} = useEventBus();

	const availableInsurances = ref([]);
	const availableServices = ref([]);
	const selectedServices = ref([]);

	function watchProps() {
		availableInsurances.value = [];
		if (props.item?.insurance_simple?.available) {
			props.item?.insurance_simple?.available.forEach(el => availableInsurances.value.push(el));
		}

		availableServices.value = [];
		if (props?.item?.service_simple?.available) {
			props.item?.service_simple?.available.forEach(el => {
				if (!el.options?.selected_value) {
					availableServices.value.push(el);
				}
			});
		}
	}
	watchProps();

	watch(
		() => props.item,
		() => {
			watchProps();
			serviceUpdate();
		}
	);

	watch(
		() => bus?.value,
		(newValue) => {
			if (newValue.event === 'servicesSelected') {
				selectedServices.value = newValue?.data?.selectedItems;
				serviceUpdate();
			}
			if(newValue.event === 'confItem') {
				selectedServices.value = [];
				serviceUpdate();
			}
		}
	);

	const serviceBid = ref(null)
	const serviceActive = ref(false)
	const insuranceActive = ref(false)
	function serviceUpdate() {
		let services = []
		let insurance = []
		if(selectedServices.value && props.item?.service_simple?.available.some(item => selectedServices.value.includes(item.id))) {
			services = props.item?.service_simple?.available.filter(item => selectedServices.value.includes(item.id));
			serviceActive.value = true;
		}
		else {
			services = [props.item?.service_simple?.available[0]];
			serviceActive.value = false;
		}

		if(selectedServices.value.length && props.item?.insurance_simple?.available.some(item => selectedServices.value.includes(item.id))) {
			insurance = props.item?.insurance_simple.available.filter(item => selectedServices.value.includes(item.id));
			insuranceActive.value = true;
		}
		else {
			insurance = [props.item?.insurance_simple?.available[0]];
			insuranceActive.value = false;
		}

		serviceBid.value = {
			service: services,
			insurance: insurance
		};
	}
	serviceUpdate();

	function flyoutService(value) {
		document.body.classList.add('flyout-page', 'cd-flyout-active');
		const content = {
			servicesAll: props.item.services,
			services: availableServices.value ? availableServices.value : [],
			insurances: availableInsurances.value ? availableInsurances.value : [],
		};
		emit('flyoutUpdate', {'flyout_title': (value == 'insurance') ? labels.get('insurances_flyout_title') : labels.get('services_flyout_title'), 'flyout_mode': value ? value : null, 'flyout_content': content ? content : null});
	}
</script>

<style lang="less" scoped>
	.cd-services-section{width: 100%; margin: 15px 0 0;}
	.cd-services-title{display: block; font-size: 15px; line-height: 1.4; font-weight: 600; margin-bottom: 10px;}

	.cd-service{
		display: flex; flex-direction: column; justify-content: center; width: 100%; margin-bottom: 10px; padding: 20px 70px; background: #F3F6FA; border: 1px solid @borderColor; cursor: pointer; position: relative; .transition(all);
		&:before{.icon-arrow-down(); font: 12px/12px @fonti; font-weight: 600; color: @blue; position: absolute; right: 25px; .rotate(-90deg);}
		&.active{
			background: #EBF4FF; border-color: @blue;
			.cd-service-title{
				&:before{content: none;}
				&:after{.pseudo(22px,22px); background: @blue; .icon-check(); font: 10px/22px @fonti; color: @white; text-align: center; text-indent: 2px; top: 10px; left: -42px;}
			}
			.cd-service-title, .cd-service-note{
				.unselected{display: none;}
				.selected{display: block;}
			}
		}
		@media (min-width: @t){
			&:hover{border-color: @hoverBorderColor; z-index: 1;}
		}

		@media (max-width: @t){
			padding: 15px 60px;
			&:before{right: 20px;}
		}
		@media (max-width: @m){
			padding-right: 50px;
			&:before{font-weight: normal; right: 17px;}
			&.active{
				.cd-service-title:after{top: 8px; left: -38px;}
			}
		}
	}
	.cd-service-title{
		font-size: 15px; line-height: 1.4; font-weight: 600; position: relative;
		&:before{.icon-services-insurance(); font: 29px/29px @fonti; color: @blue; position: absolute; left: -42px;}
		.selected{display: none;}
		&.service:before{.icon-storitve(); font-size: 31px; line-height: 31px; left: -44px;}

		@media (max-width: @t){
			&:before{font-size: 26px; line-height: 26px; left: -39px;}
			&.service:before{font-size: 28px; line-height: 28px; left: -41px;}
		}
		@media (max-width: @m){
			&:before{font-size: 29px; line-height: 29px; left: -40px; top: 4px;}
			&.service:before{font-size: 30px; line-height: 30px; left: -42px;}
		}
	}
	.cd-service-bid{
		margin-top: 3px; font-size: 14px; line-height: 1.5;
		.cd-flyout-service-title{display: block; padding: 0; font-weight: normal;}
		.cd-flyout-service-price{
			flex-shrink: unset; flex-grow: unset; margin: 0 0 0 3px; padding: 0 0 0 10px; font-size: 14px; font-weight: 600; position: relative;
			&:before{.pseudo(4px,1px); background: @textColor; top: 10px; left: 0;}
		}
	}
	.cd-service-note{
		display: block; margin-top: 3px; font-size: 14px; line-height: 1.4; font-weight: bold; color: @blue; text-decoration: underline;
		.selected{display: none;}
		@media (min-width: @t){
			&:hover{color: @blue; text-decoration: none;}
		}
	}
</style>
